export const translations = {
  // Map bot-verification gate
  mapGate: {
    blocked: "Nous n'avons pas pu vérifier votre navigateur, la carte n'a donc pas été chargée.",
    slow: 'Vérification de votre navigateur en cours. Terminez la vérification ci-dessus pour charger la carte.',
    retry: 'Réessayer',
  },
  // Rating labels
  ratings: {
    terrible: 'Terrible',
    poor: 'Mauvais',
    okay: 'Correct',
    good: 'Bien',
    excellent: 'Excellent',
  },
  // Navigation and UI
  navigation: {
    home: 'Accueil',
    about: 'À Propos',
    faq: 'FAQ',
    howTo: 'Comment Vérifier',
    privacy: 'Politique de Confidentialité',
    search: 'Rechercher des restaurants...',
    languageSwitch: 'Changer de langue',
    reportPoisoning: 'Signaler Intoxication',
    guide: 'Guide Sécurité Alimentaire',
    rights: 'Droits des Consommateurs',
    symptoms: 'Guide des Symptômes',
    navigation: 'Navigation',
    features: 'Fonctionnalités',
    chains: 'Chaînes',
    chainsCompared: 'Chaînes comparées',
    explore: 'Explorer',
    inspectionBacklog: 'Retard d\'inspection',
    clickToCollapse: 'Cliquer pour réduire',
    clickToExpand: 'Cliquer pour agrandir',
    copyright: '© 2026 Kauwen of Spauwen. Tous droits réservés.'
  },

  // Homepage content
  homepage: {
    title: 'Vérifiez l\'Hygiène du Restaurant Avant de Manger',
    subtitle: 'Cotes de Sécurité Alimentaire & Résultats d\'Inspection Hygiène',
    description: 'Vérifiez les scores d\'hygiène des restaurants avant de sortir. Consultez les inspections de sécurité alimentaire, lisez les signalements d\'autres clients et faites des choix éclairés. Signalez une intoxication alimentaire anonymement.',
    searchPlaceholder: 'Rechercher un restaurant pour vérifier l\'hygiène...',
    welcomeMessage: 'Vérifiez votre restaurant avant de manger',
    featuresTitle: 'Faites des Choix Plus Sûrs',
    anonymousReporting: 'Signalez une intoxication alimentaire anonymement - aucune inscription requise',
    officialData: 'Consultez les résultats officiels d\'inspection hygiène',
    realTimeUpdates: 'Signalements de sécurité alimentaire en temps réel d\'autres clients',
    ctaReport: 'Signaler une Intoxication',
    ctaCheck: 'Vérifier l\'Hygiène du Restaurant',
    recentReports: 'Signalements Récents de Sécurité Alimentaire',
    worstRated: 'Restaurants à Éviter - Mauvais Scores d\'Hygiène'
  },

  // Restaurant details
  restaurant: {
    details: 'Détails du Restaurant',
    address: 'Adresse',
    inspectionRating: 'Note d\'Inspection',
    lastInspection: 'Dernière Inspection',
    operatorInfo: 'Informations sur l\'Exploitant',
    reportIssue: 'Signaler un Problème de Sécurité Alimentaire',
    viewOnMap: 'Voir sur la Carte',
    safetyScore: 'Score de Sécurité Alimentaire',
    hygieneRating: 'Note d\'Hygiène',
    inspectionHistory: 'Historique des Inspections',
    noInspectionData: 'Aucune donnée d\'inspection disponible',
    ratingExcellent: 'Excellent',
    ratingGood: 'Bon',
    ratingFair: 'Correct',
    ratingPoor: 'Mauvais',
    ratingUnknown: 'Inconnu',
    share: 'Partager',
    close: 'Fermer',
    copied: 'Copié!',
    shareTitle: '{{name}} - Kauwen of Spauwen',
    shareText: 'Découvrez {{name}} (Note: {{rating}}) sur Kauwen of Spauwen!',
    detailsAndHistory: 'Détails et historique',
    expandDetails: 'Afficher les détails',
    collapseDetails: 'Masquer les détails',
    loadingDetails: 'Chargement des détails du restaurant...',
    userReports: 'Rapports d\'Utilisateurs',
    noReportsYet: 'Aucun rapport pour ce restaurant',
    beFirstToReport: 'Soyez le premier à ajouter un rapport!',
    addReport: 'Ajouter un rapport',
    tryAgain: 'Réessayer',
    noScoreChange: 'Aucun changement de score',
    inspectionSource: {
      title: 'Source des Données d\'Inspection',
      description: 'Les résultats d\'inspection affichés ici proviennent de la base de données officielle belge de sécurité alimentaire gérée par l\'Agence Fédérale pour la Sécurité de la Chaîne Alimentaire (AFSCA).',
      moreInfo: 'Pour plus d\'informations détaillées sur l\'historique d\'inspection de ce restaurant, vous pouvez',
      viewOnFoodweb: 'consulter sur Foodweb',
      info: 'Informations sur la source des données d\'inspection'
    }
  },

  // Search and filters
  search: {
    placeholder: 'Rechercher restaurants, villes ou adresses...',
    noResults: 'Aucun restaurant trouvé',
    searching: 'Recherche...',
    filterByRating: 'Filtrer par Note de Sécurité',
    showAll: 'Tout Afficher',
    nearMe: 'Près de Moi',
    recentReports: 'Signalements Récents',
    clearFilters: 'Effacer les Filtres',
    enterRestaurantName: 'Entrez le nom du restaurant...',
    loading: 'Chargement...',
    noResultsFound: 'Aucun résultat trouvé.',
    recentlyViewed: 'Consultés récemment',
    clearRecent: 'Effacer',
    emojiMeaningsQuestion: 'Que signifient ces emojis?'
  },

  // Forms and reporting
  forms: {
    reportTitle: 'Signaler une Intoxication Alimentaire',
    restaurantName: 'Nom du Restaurant',
    issueDescription: 'Décrivez votre expérience d\'intoxication alimentaire',
    dateOfVisit: 'Quand avez-vous mangé là-bas?',
    symptoms: 'Symptômes d\'Intoxication Alimentaire',
    submit: 'Envoyer le Signalement d\'Intoxication',
    submitting: 'Envoi du signalement...',
    thankYou: 'Merci d\'avoir signalé une intoxication alimentaire',
    required: 'Champ obligatoire',
    optional: 'Optionnel',
    anonymous: 'Votre signalement d\'intoxication est 100% anonyme',
    symptomsList: {
      nausea: 'Nausées',
      vomiting: 'Vomissements',
      diarrhea: 'Diarrhée',
      fever: 'Fièvre',
      cramps: 'Crampes d\'estomac',
      headache: 'Maux de tête'
    },
    whenSick: 'Quand êtes-vous tombé malade?',
    whatAte: 'Qu\'avez-vous mangé?',
    howMany: 'Combien de personnes sont tombées malades?'
  },

  // About page content
  about: {
    title: 'À Propos de Notre Plateforme Communautaire de Sécurité Alimentaire',
    subtitle: 'Signalement anonyme d\'intoxications alimentaires pour protéger la santé publique',
    missionTitle: 'Notre Mission',
    missionText: 'Nous sommes une plateforme communautaire dédiée à la prévention des intoxications alimentaires. En permettant aux consommateurs de signaler anonymement leurs expériences négatives dans les restaurants, nous créons une base de données collaborative qui aide chacun à faire des choix alimentaires plus sûrs. Notre système fournit des informations en temps réel basées sur les expériences réelles des clients.',
    howItWorksTitle: 'Comment Ça Marche',
    step1Title: 'Signalement Anonyme',
    step1Text: 'Signalez une intoxication alimentaire sans créer de compte. Votre identité reste totalement confidentielle.',
    step2Title: 'Validation Communautaire',
    step2Text: 'Les signalements multiples du même établissement créent un modèle d\'alerte pour les autres consommateurs.',
    step3Title: 'Prévention Active',
    step3Text: 'Consultez les signalements récents et les scores d\'hygiène avant de choisir où manger.',
    dataSourcesTitle: 'Nos Sources de Données',
    dataSourcesText: 'Nous combinons deux types d\'informations pour vous offrir une vue complète de la sécurité alimentaire:',
    privacyTitle: 'Votre Vie Privée Est Notre Priorité',
    privacyText: 'Tous les signalements sont 100% anonymes. Nous ne collectons aucune information personnelle identifiable. Votre signalement aide la communauté tout en protégeant votre identité.',
    whyImportantTitle: 'Pourquoi C\'est Important',
    whyImportantText: 'Les intoxications alimentaires affectent des milliers de personnes chaque année. Beaucoup de cas ne sont jamais signalés aux autorités officielles. Notre plateforme permet un signalement rapide et facile qui peut prévenir d\'autres cas et encourager les restaurants à maintenir des standards d\'hygiène élevés.',
    communityImpactTitle: 'Impact Communautaire',
    stat1: 'Signalements anonymes traités',
    stat2: 'Restaurants surveillés',
    stat3: 'Utilisateurs actifs mensuels',
    joinUsTitle: 'Rejoignez Notre Communauté',
    joinUsText: 'Ensemble, nous pouvons créer un environnement alimentaire plus sûr pour tous.'
  },

  // FAQ page content
  faq: {
    title: 'Questions Fréquentes - Intoxication Alimentaire',
    subtitle: 'Tout ce que vous devez savoir sur le signalement d\'intoxications alimentaires',
    q1Title: 'Comment signaler une intoxication alimentaire?',
    q1Answer: 'Cliquez sur n\'importe quel restaurant sur la carte ou utilisez la barre de recherche pour le trouver. Ensuite, cliquez sur "Signaler un Problème" et remplissez le formulaire anonyme avec vos symptômes et votre expérience.',
    q2Title: 'Mon signalement est-il vraiment anonyme?',
    q2Answer: 'Oui, absolument. Nous ne collectons aucune information personnelle identifiable. Pas de nom, pas d\'email, pas d\'adresse IP. Votre vie privée est totalement protégée.',
    q3Title: 'Que faire en cas d\'urgence médicale?',
    q3Answer: 'En cas de symptômes graves, contactez immédiatement les services d\'urgence (112) ou votre médecin. Notre plateforme est pour le signalement et la prévention, pas pour les urgences médicales.',
    q4Title: 'Comment sont calculés les scores d\'hygiène?',
    q4Answer: 'Les scores d\'hygiène proviennent des inspections. Les signalements communautaires sont affichés séparément pour fournir des informations supplémentaires basées sur les expériences des clients.',
    q5Title: 'Puis-je signaler une intoxication ancienne?',
    q5Answer: 'Oui, vous pouvez signaler des incidents jusqu\'à 30 jours après qu\'ils se soient produits. Les signalements plus anciens peuvent toujours être utiles pour identifier des modèles.',
    q6Title: 'Les restaurants peuvent-ils répondre aux signalements?',
    q6Answer: 'Actuellement non. Les signalements sont destinés à informer les autres consommateurs.',
    q7Title: 'Cette plateforme est-elle officielle?',
    q7Answer: 'Nous sommes une plateforme communautaire indépendante qui fournit un service basé sur l\'expérience communautaire.'
  },

  // How-to page content
  howTo: {
    title: 'Comment Vérifier la Sécurité d\'un Restaurant',
    subtitle: 'Guide étape par étape pour prendre des décisions alimentaires éclairées',
    intro: 'Suivez ces étapes simples pour vérifier la sécurité alimentaire avant de manger au restaurant:',
    step1Title: '1. Recherchez le Restaurant',
    step1Text: 'Utilisez notre barre de recherche ou cliquez directement sur la carte pour trouver le restaurant qui vous intéresse.',
    step2Title: '2. Vérifiez le Score d\'Hygiène',
    step2Text: 'Regardez le score d\'inspection. Les smileys verts indiquent de bons résultats, les rouges signalent des problèmes.',
    step3Title: '3. Lisez les Signalements Récents',
    step3Text: 'Consultez les signalements d\'intoxication alimentaire de la communauté pour voir les expériences récentes d\'autres clients.',
    step4Title: '4. Prenez une Décision Éclairée',
    step4Text: 'Combinez les données officielles et les signalements communautaires pour décider si le restaurant est sûr pour vous.',
    warningSignsTitle: 'Signaux d\'Alerte',
    warningSign1: 'Multiples signalements récents d\'intoxication',
    warningSign2: 'Mauvais score d\'inspection',
    warningSign3: 'Modèle de problèmes récurrents',
    warningSign4: 'Manque de données d\'inspection récentes',
    tipsTitle: 'Conseils de Sécurité Alimentaire',
    tip1: 'Évitez les restaurants avec des signalements multiples récents',
    tip2: 'Vérifiez la date de la dernière inspection',
    tip3: 'Faites confiance à votre instinct - si quelque chose semble louche, partez',
    tip4: 'Signalez toute intoxication pour aider les autres'
  },

  // Privacy page content
  privacy: {
    title: 'Politique de Confidentialité',
    subtitle: 'Comment nous protégeons votre anonymat',
    lastUpdated: 'Dernière mise à jour',
    intro: 'Votre vie privée est notre priorité absolue. Cette politique explique comment nous garantissons votre anonymat complet.',
    section1Title: 'Collecte de Données',
    section1Text: 'Nous ne collectons AUCUNE information personnelle identifiable. Pas de noms, pas d\'emails, pas d\'adresses IP, pas de cookies de suivi. Vos signalements sont totalement anonymes.',
    section2Title: 'Ce Que Nous Stockons',
    section2List1: 'Le nom du restaurant signalé',
    section2List2: 'La date de votre visite',
    section2List3: 'Les symptômes sélectionnés',
    section2List4: 'Votre description de l\'incident',
    section2List5: 'Un identifiant aléatoire généré (non lié à vous)',
    section3Title: 'Ce Que Nous NE Stockons PAS',
    section3List1: 'Votre nom ou toute information personnelle',
    section3List2: 'Votre adresse email ou numéro de téléphone',
    section3List3: 'Votre adresse IP',
    section3List4: 'Information de localisation précise',
    section3List5: 'Toute donnée de dispositif ou de navigateur',
    section4Title: 'Comment Nous Assurons l\'Anonymat',
    section4Text: 'Chaque signalement reçoit un identifiant aléatoire qui ne peut pas être retracé jusqu\'à vous. Nous n\'utilisons pas de cookies, de pixels de suivi ou toute technologie qui pourrait identifier les utilisateurs.',
    section5Title: 'Partage de Données',
    section5Text: 'Nous ne vendons, n\'échangeons ni ne partageons jamais de données avec des tiers. Les signalements anonymisés sont visibles publiquement sur notre plateforme pour aider d\'autres consommateurs.',
    section6Title: 'Vos Droits',
    section6Text: 'Puisque nous ne collectons aucune information personnelle, il n\'y a aucune donnée personnelle à demander, modifier ou supprimer. Votre anonymat est garanti par conception.',
    section7Title: 'Contact',
    section7Text: 'Pour des questions sur cette politique de confidentialité, veuillez nous contacter via le formulaire sur notre site web.'
  },

  // Common UI elements
  common: {
    loading: 'Chargement...',
    error: 'Une erreur s\'est produite',
    retry: 'Réessayer',
    cancel: 'Annuler',
    save: 'Enregistrer',
    close: 'Fermer',
    back: 'Retour',
    next: 'Suivant',
    submit: 'Soumettre',
    search: 'Rechercher',
    filter: 'Filtrer',
    sort: 'Trier',
    share: 'Partager',
    report: 'Signaler',
    viewMore: 'Voir Plus',
    viewLess: 'Voir Moins',
    noData: 'Aucune donnée disponible',
    yes: 'Oui',
    no: 'Non',
    confirm: 'Confirmer',
    delete: 'Supprimer',
    edit: 'Modifier',
    add: 'Ajouter',
    new: 'Nouveau',
    all: 'Tout',
    none: 'Aucun',
    select: 'Sélectionner',
    selected: 'Sélectionné',
    clear: 'Effacer',
    reset: 'Réinitialiser',
    apply: 'Appliquer',
    download: 'Télécharger',
    upload: 'Téléverser',
    refresh: 'Actualiser',
    print: 'Imprimer',
    export: 'Exporter',
    import: 'Importer',
    copy: 'Copier',
    paste: 'Coller',
    cut: 'Couper',
    undo: 'Annuler',
    redo: 'Rétablir',
    previous: 'Précédent',
    copied: 'Copié!',
    showMore: 'Voir Plus',
    showLess: 'Voir Moins',
    readMore: 'Lire Plus',
    readLess: 'Lire Moins',
    tryAgain: 'Réessayer',
    page: 'Page',
    of: 'de',
    perPage: 'par page',
    noResults: 'Aucun résultat trouvé',
    locateMe: 'Me localiser',
    toggleMenu: 'Basculer le menu',
    loadingRestaurant: 'Chargement du restaurant...',
    loadingDetails: 'Chargement...',
    addYourReport: 'Ajouter votre rapport',
    words: 'mots',
    star: 'étoile',
    stars: 'étoiles'
  },

  // SEO Keywords (for meta tags and content)
  seo: {
    keywords: {
      foodSafety: 'sécurité alimentaire',
      restaurantHygiene: 'hygiène restaurant',
      anonymousReporting: 'signalement anonyme intoxication',
      restaurants: 'restaurants hygiène',
      foodInspection: 'inspection alimentaire',
      foodPoisoning: 'intoxication alimentaire',
      reportingPlatform: 'plateforme signalement restaurant',
      communityDriven: 'communauté sécurité alimentaire',
      healthInspection: 'inspection sanitaire restaurant',
      consumerProtection: 'protection consommateur'
    }
  },

  // Emoji meanings
  emoji: {
    meanings: {
      title: 'Signification des Emojis',
      skull: 'Mauvaise inspection deux fois avec rapport de police',
      sick: 'Échec de l\'inspection avec avertissement, en attente de réinspection',
      slight_smile: 'Mauvaise inspection mais problèmes résolus après réinspection',
      smile: 'Réussite de la dernière inspection',
      heart_eyes: 'Validé par une société externe',
      question: 'Statut inconnu ou pas de données'
    },
    selectEmoji: 'Sélectionner emoji: {{emoji}}'
  },

  // Wall of Shame
  wallOfShame: {
    title: 'Mur de la Honte',
    subtitle: 'Affichage des établissements avec les pires résultats d\'inspection de sécurité alimentaire.',
    foundCount: '{{count}} établissements trouvés avec la note "Te verbeteren"',
    showingPage: 'Affichage de la page',
    noEstablishments: 'Aucun établissement avec de mauvaises notes trouvé.',
    columns: {
      id: 'ID',
      name: 'Nom',
      address: 'Adresse',
      inspectionDate: 'Date d\'Inspection',
      details: 'Détails'
    }
  },

  // Data Table
  dataTable: {
    title: 'Tableau de Données',
    filterByStatus: 'Filtrer par Statut:',
    columns: {
      id: 'ID',
      name: 'Nom',
      address: 'Adresse',
      status: 'Statut',
      tooltip: 'Info-bulle',
      inspectionResult: 'Résultat d\'inspection'
    },
    statuses: {
      toImprove: 'Te verbeteren',
      good: 'Goed',
      veryGood: 'Zeer goed'
    }
  },

  // Report Form
  reportForm: {
    title: 'Créer un Nouveau Rapport',
    createNewReport: 'Créer un Nouveau Rapport',
    successMessage: 'Rapport soumis avec succès!',
    shareYourReport: 'Partagez votre signalement',
    done: 'Terminé',
    anonymousUsername: 'Votre Nom d\'Utilisateur Anonyme',
    privacyNote: 'Pour la confidentialité, nous générons un nom d\'utilisateur aléatoire pour chaque rapport',
    yourUsername: 'Votre Nom d\'Utilisateur Anonyme',
    usernameInfo: 'Pour la confidentialité, nous générons un nom d\'utilisateur aléatoire pour chaque rapport',
    yourReport: 'Votre Rapport',
    placeholder: 'Partagez votre expérience avec ce restaurant...',
    reportPlaceholder: 'Partagez votre expérience avec ce restaurant...',
    wordCount: '{{count}} / {{max}} mots',
    wordLimit: 'Veuillez limiter votre rapport à {{limit}} mots',
    wordLimitExceeded: 'Veuillez limiter votre rapport à {{limit}} mots',
    rateExperience: 'Évaluez Votre Expérience',
    selectRating: 'Sélectionnez une note',
    selectedRating: 'Vous avez noté ce restaurant {{rating}} sur 5 étoiles',
    youRated: 'Vous avez noté ce restaurant',
    submitting: 'Soumission...',
    addReport: 'Ajouter un Rapport',
    cancel: 'Annuler',
    addImage: 'Ajouter une Image (Optionnel)',
    clickToUpload: 'Cliquez pour télécharger',
    imageRequirements: 'PNG, JPG jusqu\'à 15MB',
    imageTooLarge: 'La taille de l\'image doit être inférieure à {{size}}',
    invalidImageType: 'Veuillez télécharger un fichier image valide',
    imageLoadError: 'Échec du chargement de l\'image',
    loadingImage: 'Chargement de l\'image...',
    detailsOptional: 'Détails (Optionnel)',
    symptomsLabel: 'Symptômes',
    visitDateLabel: 'Date de visite',
    dishOrderedLabel: 'Plat commandé',
    dishOrderedPlaceholder: 'ex. pâtes, sushi...'
  },

  // Time formatting
  time: {
    justNow: 'à l\'instant',
    minuteAgo: 'il y a 1 minute',
    minutesAgo: 'il y a {{count}} minutes',
    hourAgo: 'il y a 1 heure',
    hoursAgo: 'il y a {{count}} heures',
    dayAgo: 'il y a 1 jour',
    daysAgo: 'il y a {{count}} jours',
    weekAgo: 'il y a 1 semaine',
    weeksAgo: 'il y a {{count}} semaines',
    monthAgo: 'il y a 1 mois',
    monthsAgo: 'il y a {{count}} mois',
    yearAgo: 'il y a 1 an',
    yearsAgo: 'il y a {{count}} ans'
  },

  // Restaurant History
  restaurantHistory: {
    passedInspection: 'Inspection réussie',
    receivedWarning: 'Avertissement reçu',
    inspectionTooOld: 'Inspection trop ancienne',
    awaitingInspection: 'En attente de nouvelle inspection',
    receivedFine: 'Amende reçue',
    receivedPV: 'PV reçu'
  },

  // Recent Reports
  recentReports: {
    title: 'Rapports Récents',
    ariaLabel: 'Rapports Récents'
  },

  // Sidebar
  sidebar: {
    recentReports: 'Rapports Récents',
    trends: 'Tendances'
  },

  // Trends
  trends: {
    title: 'Restaurants Tendance',
    loading: 'Chargement des tendances...',
    error: 'Échec du chargement des tendances',
    noTrends: 'Aucune donnée de tendance disponible',
    noTrendsSubtext: 'Les données de tendance apparaîtront ici lorsqu\'elles seront disponibles',
    cityNoTrends: 'Aucun changement de score récent à {{city}}',
    cityNoTrendsSubtext: 'Les inspections ici ont récemment conservé le même score',
    showNationalTrends: 'Voir les tendances pour toute la Belgique',
    noUpwardTrends: 'Aucune tendance à la hausse disponible',
    noDownwardTrends: 'Aucune tendance à la baisse disponible',
    restaurants: 'restaurants',
    summary: 'Résumé des Tendances',
    improving: 'En amélioration',
    declining: 'En déclin',
    popular: 'Populaire',
    new: 'Nouveau',
    reports: 'rapports',
    points: 'points',
    lastUpdated: 'Dernière mise à jour',
    cta: 'Cliquez sur un restaurant pour voir les détails et l\'historique des inspections.',
    significantImprovements: '{{count}} améliorations significatives',
    significantDeclines: '{{count}} baisses significatives',
    avgPoints: 'Moy: {{value}} points',
    noResultsFiltered: 'Aucun résultat',
    minChange: 'Changement min:',
    all: 'Tous',
    sortByChange: 'Changement',
    sortByName: 'Nom',
    sortByDate: 'Date',
    significantChanges: 'Grands changements',
    recentInspections: 'Derniers 30 jours',
    bigChanges: 'Grands changements seulement',
    mostRecent: 'Plus récent',
    daysAgo: 'jours'
  },

  // Reports section
  reports: {
    loading: 'Chargement des rapports récents...',
    error: 'Échec du chargement des rapports',
    noReports: 'Aucun rapport récent disponible',
    noReportsSubtext: 'Les rapports apparaîtront ici dès qu\'ils seront soumis',
    latestReports: 'Derniers Rapports de Sécurité Alimentaire',
    reports: 'Rapports',
    summary: 'Résumé d\'Activité Récente',
    totalReports: 'Total des Rapports',
    avgRating: 'Note Moyenne',
    activeRestaurants: 'Restaurants Récents',
    activeCities: 'Villes Actives',
    cta: 'Avez-vous rencontré des problèmes de sécurité alimentaire? Partagez votre expérience pour aider les autres à prendre des décisions éclairées.'
  },

  // Navigation keys
  nav: {
    home: 'Accueil',
    about: 'À Propos',
    faq: 'FAQ',
    howToCheck: 'Comment Vérifier',
    privacy: 'Politique de Confidentialité'
  },

  // Comparison badges
  comparison: {
    whyThisScore: 'Pourquoi ce score?',
    aboveAverage: 'au-dessus de la moyenne',
    belowAverage: 'en-dessous de la moyenne',
    verdict: {
      topCategory: 'Le mieux noté {{category}} dans {{area}}.',
      topPostal: 'Le restaurant le mieux noté dans {{postalCode}}.',
      topCity: 'Le restaurant le mieux noté dans {{cityName}}.',
      topPercentile: 'Top {{percentile}}% dans {{cityName}}.',
      ranked: 'Classé #{{rank}} parmi {{total}} dans {{area}}, score {{diff}} points {{aboveBelow}}.'
    },
    breakdown: {
      history: 'Historique',
      forks: 'Note Officielle',
      reports: 'Rapports Utilisateurs',
      officialRating: 'note officielle',
      basedOnReports: 'Basé sur {{count}} rapports utilisateurs',
      noHistory: 'Aucun historique d\'inspection disponible',
      historyWarning: 'A des avertissements ou amendes dans l\'historique',
      historyStrong: 'Réussit régulièrement les inspections',
      historyNeutral: 'Historique d\'inspection mixte'
    },
    labels: {
      city: 'Ville',
      area: 'Zone',
      category: 'Catégorie'
    },
    betterThan: 'Mieux que {{percent}}%',
    inWorst: 'Parmi les pires {{percent}}%',
    inBest: 'Parmi les meilleurs {{percent}}%',
    quality: {
      excellent: 'Excellent',
      good: 'Bon',
      average: 'Moyen',
      belowAvg: 'Sous moy.'
    },
    historyStatus: {
      noData: 'Pas de données',
      hasIssues: 'A des problèmes',
      clean: 'Propre',
      mixed: 'Mixte'
    }
  },

  // Badge embed
  badge: {
    triggerLink: 'Votre établissement?',
    modalTitle: 'Affichez Votre Note',
    modalDescription: 'Fier de votre score d\'hygiène? Affichez-le sur votre site web ou réseaux sociaux pour gagner la confiance des clients.',
    embedLabel: 'Intégrer sur votre site',
    embedBadge: 'Badge de site web',
    imageUrlLabel: 'Ou partagez l\'URL de l\'image',
    preview: 'Aperçu du Badge',
    tabs: {
      embed: 'Code d\'intégration',
      showcase: 'Vitrine QR'
    },
    showcase: {
      scanToVerify: 'Scanner pour vérifier',
      downloadPng: 'Télécharger PNG',
      downloading: 'Génération...',
      printTip: 'Optimisé pour l\'impression à 300 DPI',
      forks: '{{count}} Fourchettes',
      ratingLabel: {
        '5': 'Excellent',
        '4': 'Très Bon',
        '3': 'Bon',
        '2': 'Médiocre',
        '1': 'Critique'
      }
    }
  },

  // Subscription
  subscription: {
    notifyMe: 'M\'avertir des changements de notation',
    title: 'Restez Informé',
    description: 'Recevez une notification lorsque la note d\'inspection de {{restaurantName}} change',
    emailPlaceholder: 'Entrez votre adresse e-mail',
    subscribe: 'S\'abonner',
    subscribing: 'Abonnement en cours...',
    success: 'Abonnement réussi!',
    privacy: 'Nous utiliserons votre e-mail uniquement pour vous envoyer des mises à jour sur la notation de ce restaurant.',
    invalidEmail: 'Veuillez entrer une adresse e-mail valide',
    alreadySubscribed: 'Vous êtes déjà abonné aux mises à jour pour ce restaurant',
    error: 'Échec de l\'abonnement. Veuillez réessayer plus tard.',
    close: 'Fermer',
    onePersonWatching: '1 personne suit',
    peopleWatching: '{{count}} personnes suivent'
  },

  score: {
    excellent: 'Excellent',
    good: 'Bon',
    poor: 'Mauvais',
    bad: 'Très Mauvais',
    unknown: 'Inconnu'
  },

  city: {
    subtitle: 'Aperçu de l\'hygiène des restaurants',
    noData: 'Aucune donnée disponible pour {{city}}',
    noDataHint: 'Essayez de rechercher des restaurants dans cette zone sur la carte',
    avgExplain: 'score d\'hygiène moyen de {{count}} restaurants',
    alertTitle: 'Recevez des alertes pour {{city}}',
    alertDescription: 'Soyez le premier informé lorsque des problèmes de sécurité alimentaire apparaissent à {{city}}',
    alertSuccess: 'Vous êtes abonné!',
    alertPlaceholder: 'votre@email.com',
    alertButton: 'M\'alerter',
    alertError: 'Déjà abonné ou réessayez plus tard',
    avoid: 'À Éviter',
    safe: 'Choix Sûrs',
    prose: {
      overview: '{{city}} compte {{count}} restaurants inspectés avec un score d\'hygiène moyen de {{avg}}/5.',
      reports: '{{count}} signalements de sécurité alimentaire ont été déposés par des clients à {{city}}.',
      topPick: 'Meilleure note : {{name}}.',
      warning: '{{count}} restaurants signalés pour mauvaise hygiène.'
    }
  },

  province: {
    prose: {
      overview: '{{province}} compte {{count}} restaurants inspectés avec un score d\'hygiène moyen de {{avg}}/5.',
      reports: '{{count}} signalements de sécurité alimentaire ont été déposés dans la province de {{province}}.',
      topPick: 'Meilleure note : {{name}}.'
    }
  },

  chain: {
    sectionTitle: 'Fait partie d\'une chaîne ?',
    sectionBody: '{{count}} établissements portent ce nom dans notre base de données.',
    sectionAvg: 'Score AFSCA moyen de tous les établissements : {{avg}}/5',
    sectionLink: 'Voir tous les établissements',
    pageSubtitle: 'Établissements portant ce nom en Belgique',
    avgExplain: 'score AFSCA moyen sur {{count}} établissements inspectés',
    scoredPct: '{{pct}}% des établissements ont un score d\'inspection récent',
    locations: 'Établissements ({{count}})',
    sortCity: 'Par commune',
    sortScoreAsc: 'Score : bas → haut',
    sortScoreDesc: 'Score : haut → bas',
    distribution: 'Répartition des scores',
    unscored: '{{count}} établissements sans score récent',
    share: 'Partager',
    shareText: '{{name}} : score AFSCA moyen de {{avg}}/5 sur {{count}} établissements',
    methodology: 'Moyennes basées sur les résultats d\'inspection officiels de l\'AFSCA par établissement. Les établissements sont regroupés par nom et peuvent appartenir à des exploitants différents.',
    noData: 'Aucune donnée trouvée pour cette chaîne',
    prose: {
      overview: '{{name}} compte {{count}} établissements dans notre base de données, dont {{scored}} avec un score d\'inspection AFSCA récent. Le score moyen est de {{avg}} sur 5.'
    },
    rankings: {
      title: 'Chaînes comparées',
      subtitle: 'Scores d\'inspection AFSCA moyens par chaîne',
      intro: 'Comparez les chaînes de supermarchés, de fast-food et de magasins selon le score d\'inspection AFSCA moyen de leurs établissements.',
      sortBySize: 'Nombre d\'établissements',
      sortByScoreDesc: 'Score : haut → bas',
      sortByScoreAsc: 'Score : bas → haut',
      minSize: 'Min. établissements',
      locationCount: '{{count}} établissements',
      noData: 'Pas encore de données sur les chaînes'
    }
  },

  backlog: {
    title: 'Retard d\'inspection',
    subtitle: 'Établissements actifs dont la dernière inspection AFSCA était défavorable et date d\'au moins 2 ans',
    statExplain: 'établissements avec un score défavorable et aucun résultat d\'inspection depuis 2 ans ou plus',
    oldest: 'Résultat défavorable le plus ancien : {{date}}',
    allProvinces: 'Toutes',
    lastInspection: 'Dernière inspection {{date}} · il y a {{years}} ans',
    loadMore: 'Afficher plus ({{shown}}/{{total}})',
    noData: 'Aucune donnée disponible',
    methodology: 'Basé sur les résultats d\'inspection publics de l\'AFSCA. Un score ancien ne dit rien de la situation actuelle ; il n\'existe simplement aucun résultat plus récent dans les données publiques.'
  }
};
